export default __webpack_public_path__ + "static/media/128380ded41312f5a5713754728c8daf.svg";